import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {FileItem, FileLikeObject, FileUploader, FileUploaderOptions} from 'ng2-file-upload';
import {ARQUIVOS_PERMITIDOS} from 'src/app/tools/Files';
import {
  ERRO_ANEXAR_ARQ,
  ERRO_FORMATO_ARQ,
  ERRO_TAMANHO_ARQ,
  ERRO_LIMITE_ARQ,
  ERRO_NOME_IGUAL_ARQ
} from 'src/app/tools/Mensagens';

export const FILE_UPLOADER = 'fileUploader';

@Component({
  selector: 'file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.css']
})
export class FileUploaderComponent implements OnInit {
  mapFilesBase64 = new Map();
  uploader: FileUploader;
  opcoes: FileUploaderOptions = {
    queueLimit: 2,
    allowedMimeType: ARQUIVOS_PERMITIDOS,
    maxFileSize: 10 * 1024 * 1024
  };
  @Input() tituloLabel: string;
  @Input() arquivosSalvos: any[];
  @Input() apenasUmAnexo: boolean;
  @Input() quantidadeAnexo: number;
  @Input() styleCarbon: boolean = false;
  @Input() formSubmitted: boolean = false;
  @Input() require: boolean = false;
  @Input() inputId: string = 'anexo-bank';

  titulo = 'Anexos: ';

  @Output() arquivosChange = new EventEmitter<any[]>(); // ADICIONE ESTA LINHA

  constructor() {
  }

  get possuiArquivos(): boolean {
    return this.uploader && this.uploader.queue.length > 0;
  }

  get isInvalid(): boolean {
    if(this.require){
      return this.styleCarbon && this.formSubmitted && !this.possuiArquivos;
    }
  }

  get isValid(): boolean {
    if(this.require){
      return this.styleCarbon && this.formSubmitted && this.possuiArquivos;
    }else{
      return this.styleCarbon && this.formSubmitted;
    }
  }

  get errorMessage(): string {
    return 'Campo obrigatório';
  }

  ngOnInit() {

    const minUpload = 1;
    const maxUpload = 2;

    // valor padrão
    this.opcoes.queueLimit = maxUpload;

    // Definir limite de anexos
    if (this.apenasUmAnexo) {
      this.opcoes.queueLimit = minUpload;
    } else if (this.quantidadeAnexo !== null && this.quantidadeAnexo !== undefined) {
      this.opcoes.queueLimit = this.quantidadeAnexo;
    }


    this.uploader = new FileUploader(this.opcoes);
    this.uploader.onAfterAddingFile = (item: FileItem) => {
      this.validarItem(item);
      this.preencherFiles();
    }


    if (this.tituloLabel != null && this.tituloLabel != '') {
      this.titulo = this.tituloLabel;
    }

    this.uploader.onWhenAddingFileFailed = (item: FileLikeObject, filter) => {
      switch (filter.name) {
        case 'mimeType': {
          alert(ERRO_FORMATO_ARQ);
          break;
        }
        case 'fileSize': {
          alert(ERRO_TAMANHO_ARQ);
          break;
        }
        case 'queueLimit': {
          alert(ERRO_LIMITE_ARQ(this.opcoes.queueLimit));
          break;
        }
        default:
          alert(ERRO_ANEXAR_ARQ);
      }
    }

    if(this.styleCarbon){
      this.carregarArquivosSalvos();
    }else{
      this.carregarArquivosSalvos();
      this.carregarArquivosSalvos();
    }
  }

  validarItem(item: FileItem) {
    console.log(item);
    console.log(this.uploader.queue);
    if (this.uploader.queue.filter(anex => anex.file.name == item.file.name).length > 1) {;
      this.uploader.removeFromQueue(item);
      alert(ERRO_NOME_IGUAL_ARQ);
    }
  }

  remover(fileToRemove) {

    this.uploader.queue.splice(this.uploader.queue.indexOf(fileToRemove), 1);

    let keyMap = '';
    this.mapFilesBase64.forEach((value, key) => {

      const indexHifen = key.indexOf('-');
      let nomeArquivo = key.substring(indexHifen + 2, key.length);
      const split = nomeArquivo.split('/type=');
      if (split[0] === fileToRemove._file.name) {

        keyMap = key;

        return;

      }

    });
    this.mapFilesBase64.delete(keyMap);
    this.emitirArquivos();
  }

  async preencherFiles() {
    this.mapFilesBase64 = new Map();
    for (const [index, item] of this.uploader.queue.entries()) {
      await this.tratarFile(index, item._file);
    }
    this.emitirArquivos();
  }

  emitirArquivos() {
    const arquivos = [];
    this.mapFilesBase64.forEach((conteudo, nomeArquivo) => {
      arquivos.push({ nomeArquivo, conteudo });
    });
    this.arquivosChange.emit(arquivos);
  }

  carregarArquivosSalvos() {

    if (this.arquivosSalvos) {

      let files: File[] = [];
      this.arquivosSalvos.forEach(arquivoSalvo => {
        const byteCharacters = atob(arquivoSalvo.conteudo.replace(/\s/g, ''));
        const buffer = new ArrayBuffer(byteCharacters.length);
        const view = new Uint8Array(buffer);

        for (let i = 0; i < byteCharacters.length; i++) {
          view[i] = byteCharacters.charCodeAt(i);
        }

        const split = arquivoSalvo.nomeArquivo.split('/type=');
        const nomeArquivoSplit = split[0];
        const type = split[1];
        const blob = new Blob([view], {type});
        const indexHifen = nomeArquivoSplit.indexOf('-');
        let nomeArquivo = nomeArquivoSplit.substring(indexHifen + 2, nomeArquivoSplit.length);
        let file = new File([blob], nomeArquivo, {type, lastModified: new Date().getMilliseconds()});
        files.push(file);

      })
      this.uploader.addToQueue(files);

    }

  }

  async tratarFile(index, file: File) {
    const retorno = await this.readBase64(file);
    const base = retorno.split('base64,')[1];
    this.mapFilesBase64.set(index + " - " + file.name + '/type=' + file.type, base);
  }

  readBase64(file): Promise<any> {
    var reader = new FileReader();
    var future = new Promise((resolve, reject) => {
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.addEventListener("error", function (event) {
        reject(event);
      }, false);

      reader.readAsDataURL(file);
    });
    return future;
  }

}
